import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import AdminHeader from "../Headers/AdminHeader";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Footer from "../Footers/Footer";
import AuthService from "../../services/AuthService";
import SuccessAlerts from "../Alerts/SuccessAlerts";
import ErrorAlerts from "../Alerts/ErrorAlerts";
import WarningAlerts from "../Alerts/WarningAlerts";
import MessageAlerts from "../Alerts/MessageAlerts";
import { Container } from "react-bootstrap";
import LoginHeader from "../Headers/LoginHeader";
import history from "../../history";
import { fetchActivePermissions } from "../../actions/PermissionActions";
import StudentService from "../../services/StudentService";
import { isAuthenticated } from "../../actions/AuthActions";
import UserSideBarWrapper from "../Headers/UserSideBarWrapper";
import CognitoToggleComponent from "../ToggleComponents/CognitoToggleComponent";


const AdminLayout = (props) => {
  if (props.isAuth) {
    return (
      <>
        <div id="contentWrap">
        {!props.hideHeader && <AdminHeader />}
          <SuccessAlerts />
          <ErrorAlerts />
          <WarningAlerts />
          <MessageAlerts />
          <Container fluid className="mt-1 main-content">
            {props.children}
          </Container>
        </div>
        {!props.hideFooter && <Footer />}
      </>
    );
  } else {
    return (
      <Redirect
        to={{
          pathname: "/ssoLogin",
        }}
      />
    );
  }
};

const UserLayout = (props) => {
  const defaultComponent = () => {
    return (
      <>
        <div id="contentWrap">
          <LoginHeader />
          <SuccessAlerts />
          <ErrorAlerts />
          <WarningAlerts />
          <MessageAlerts />
          <Container fluid className="mt-1 main-content">
            {props.children}
          </Container>
        </div>
        <Footer />
      </>
    )
  }

  const toggledComponent = () => {
    return (
      <div id="contentWrap">
        {!props.hideHeader && <UserSideBarWrapper
          content={props.children}
        >
          <SuccessAlerts />
          <ErrorAlerts />
          <WarningAlerts />
          <MessageAlerts />
        </UserSideBarWrapper>}
      </div>
    )
  }


  if (props.isAuth) {
    return (
      <>
        <CognitoToggleComponent
          studentOnly={true}
          defaultComponent={defaultComponent()}
          toggledComponent={toggledComponent()} />
      </>
    );
  } else {
    return (
      <Redirect
        to={{
          pathname: "/login",
        }}
      />
    );
  }
};
class LayoutPointer extends React.Component {
  state = { loaded: false, isAuthenticated: false, userType: "User", uuids: [] };
  userAllowedList = ["studenttasklist", "parenttasklist", "interview", "studentprofile"];

  async componentDidMount() {
    let currentRole = null;
    if (this.props.role === null || typeof(this.props.role) == "undefined" || !this.props.role) {
      currentRole = await this.props.isAuthenticated();
    } else {
      currentRole = this.props.role;
    }

    // Load active user permissions into redux so we can authorize a user to access components and pages
    if (!this.props.permissionStore.activePermissions) {
      this.props.fetchActivePermissions();
    }

    if (AuthService.NonStudentRoles.includes(currentRole)) {
      this.setState({ isAuthenticated: true, userType: currentRole });
    } else {
      this.setState({ isAuthenticated: false });
    }
    let students = (!currentRole || currentRole === "User") ? await StudentService.getStudentsByStudentAccountID(this.props.accountID) : [];
    this.setState({ uuids: students.map(x => x.uuid), loaded: true });
  }
  
  render() {
    const { component: Component, ...rest } = this.props;
    if (this.state.loaded) {
      return (
        <Route
          {...rest}
          render={(matchProps) => {
            if (AuthService.NonStudentRoles.includes(this.state.userType)) {
              return (
                <AdminLayout isAuth={this.state.isAuthenticated} 
                  hideHeader={this.props.hideHeader} hideFooter={this.props.hideFooter}>
                  <Component {...matchProps} userType={this.state.userType} />
                </AdminLayout>
              );
            } else if (this.state.userType === "User") {
              if (
                ((this.props.userAllowed &&
                  this.props.computedMatch &&
                  this.userAllowedList.includes(
                    this.props.computedMatch.params.component.toLowerCase()
                  )) ||
                this.props.location.pathname.includes("userWelcome")) &&
                (!matchProps.match.params.uuid || this.state.uuids.includes(matchProps.match.params.uuid))
              ) {
                return (
                  <UserLayout isAuth>
                    <Component {...matchProps} userType={this.state.userType} />
                  </UserLayout>
                );
              } else {
                history.goBack();
              }
            }
          }}
        />
      );
    } else {
      return <LoadingComponent />;
    }
  }
}

const mapStateToProps = (state) => {
  return { 
    permissionStore: state.permissionStore,
    accountID: state.auth?.user?.id,
    role: state.auth.role
  };
};
export default connect(mapStateToProps, {
  fetchActivePermissions,
  isAuthenticated
})(LayoutPointer);
